import React from 'react'
import { setTermsAndConditions } from './termsSlice'
import { useAppDispatch, useAppSelector } from '@/hooks'
import type { RootState } from '@/store'

import CheckAndLabel from '@components/check/CheckAndLabel'

function Terms(props: { required: boolean }) {
	const dispatch = useAppDispatch()
	const checked = useAppSelector((state: RootState) => state.terms.termsAndConditions)

	const id = 'termsAndConditions'

	const handleSetTerms = (value: boolean) => {
		console.log('Terms: ', value)
		dispatch(setTermsAndConditions(value))
	}

	return (
		<CheckAndLabel
			id={id}
			name={id}
			text="J'ai lu et j'accepte les conditions générales de vente"
			checked={checked}
			required={props.required}
			onChange={handleSetTerms}
		/>
	)
}

export default Terms
